<template>
    <div class="d-flex flex-column mb-3">
        <!-- Observations card -->
        <div class="card p-3">
            <div class="d-flex flex-row justify-content-between mb-3">
                <div class="fw-medium mb-2 text-success">
                    <font-awesome-icon icon="search" />
                    {{ $t('video_recordings.observations') }}
                    <span
                        v-if="hasObservations"
                        class="text-muted"
                    >
                        ({{ observations.length }})
                    </span>
                </div>
            </div>

            <!-- Empty state -->
            <div
                v-if="!hasObservations && !observationsLoading"
                class="text-muted small py-2"
            >
                {{ $t('video_recordings.no_observations') }}
            </div>

            <div
                v-if="observationsLoading"
                class="text-muted small py-2"
            >
                {{ $t('common.loading') }}
            </div>

            <!-- Table (same datatable as the main observations screen) -->
            <video-observations-table
                v-if="hasObservations"
                :observations="observations"
                :selected-observation-id="selectedObservationId"
                @row-click="$emit('select-observation', $event)"
                @seek-observation="$emit('seek-observation', $event)"
            />
        </div>
    </div>
</template>

<script>
import { restApi } from '../mixins/RestApiMixin';
import ObservationResultSummary from '../observation/ObservationResultSummary.vue';
import VideoObservationsTable from './VideoObservationsTable.vue';

export default {
    name: "VideoObservations",
    components: {
        ObservationResultSummary,
        VideoObservationsTable
    },
    mixins: [restApi],
    props: {
        observations: {
            type: Array,
            default: null
        },
        selectedObservationId: {
            type: [Number, String],
            default: null
        },
        observationsLoading: {
            type: Boolean,
            default: false
        }
    },
    emits: ['select-observation', 'seek-observation'],
    computed: {
        hasObservations() {
            return !!(this.observations && this.observations.length)
        }
    }
}
</script>
